// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a0769cb6","879":"4c829e8a"}[chunkId] + ".chunk.js";
};